const ShortName = (str: string) => {
  return str
    ?.split(" ")
    ?.filter((item: any) => item != "")
    ?.map((item: any) => item[0]?.toUpperCase())
    .join("");
};

export default ShortName;
